import { AutoComplete } from '@geerd-nx/ui';
import {
  useInsert_Tag_OneMutation,
  TagQuery,
} from '@geerd-nx/shareable-graphql';
import React from 'react';
type Tag = TagQuery['tag'][number];
interface TagSelectorProps {
  tags: Tag[];
  setSearchTag: React.Dispatch<React.SetStateAction<string>>;
  setTagsToSave: React.Dispatch<React.SetStateAction<Partial<Tag>[]>>;
  tagsToSave: Partial<Tag>[];
  searchTag: string;
  loadingTags: boolean;
  createTagMutation: ReturnType<typeof useInsert_Tag_OneMutation>['0'];
}

function TagSelector({
  tags,
  setSearchTag,
  tagsToSave,
  setTagsToSave,
  searchTag,
  loadingTags,
  createTagMutation,
}: TagSelectorProps) {
  return (
    <div className="bg-white p-5 mt-3 flex items-center">
      <span className="text-sm font-medium text-gray-700 mr-5">
        Select at least one tag
      </span>

      <div className="flex items-center space-x-2">
        <div className="max-w-lg rounded-md sm:max-w-xs">
          <AutoComplete<Tag>
            placeholder="Search tag..."
            setSearch={setSearchTag}
            setValue={(option) => {
              setTagsToSave((prevState) => [
                ...prevState,
                {
                  id: option?.id,
                  label: option?.label,
                } as unknown as Tag,
              ]);
              setSearchTag('');
            }}
            search={searchTag}
            isLoading={loadingTags}
            accessor={'label'}
            create={(value) => {
              createTagMutation({
                variables: {
                  object: {
                    label: value,
                  },
                },
              }).then(({ data }) => {
                setTagsToSave((prevState) => [
                  ...prevState,
                  {
                    id: data?.insert_tag_one?.id,
                    label: data?.insert_tag_one?.label,
                  },
                ]);
              });
            }}
            data={tags}
          />
        </div>{' '}
        <div className="sm:rounded-md divide-y flex flex-wrap space-x-2 divide-gray-200">
          {tagsToSave.map((tag) => (
            <span
              key={tag.id}
              className="inline-flex mt-1 rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-primary-100 text-primary-700"
            >
              {tag.label}
              <button
                onClick={() =>
                  setTagsToSave((prevState) => {
                    const stateToSave = prevState.filter(function (item) {
                      return item.id !== tag.id;
                    });

                    return stateToSave;
                  })
                }
                type="button"
                className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-primary-400 hover:bg-primary-200 hover:text-primary-500 focus:outline-none focus:bg-primary-500 focus:text-white"
              >
                <span className="sr-only">Remove large option</span>
                <svg
                  className="h-2 w-2"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 8 8"
                >
                  <path
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M1 1l6 6m0-6L1 7"
                  />
                </svg>
              </button>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export { TagSelector };
